import { render, staticRenderFns } from "./BillDeleted.vue?vue&type=template&id=ab4e66ba&scoped=true"
import script from "./BillDeleted.vue?vue&type=script&lang=js"
export * from "./BillDeleted.vue?vue&type=script&lang=js"
import style0 from "./BillDeleted.vue?vue&type=style&index=0&id=ab4e66ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4e66ba",
  null
  
)

export default component.exports